import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import '@fontsource-variable/inter';
import './index.css';
import { ApiError } from './lib/api';
import { ME_KEY } from './lib/auth';
import { initTheme } from './lib/theme';
import { router } from './router';
import { ToastProvider } from './components/ui/toast';

initTheme();

// A 401 anywhere means the session ended (idle timeout, sign-out elsewhere, role
// change): refresh who we are, and the auth gate routes to sign-in or MFA.
const onError = (e: unknown) => {
  if (e instanceof ApiError && e.status === 401) void queryClient.invalidateQueries({ queryKey: ME_KEY });
};

const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
